import * as msal from '@azure/msal-browser';
import { InteractionRequiredAuthError } from '@azure/msal-browser';
import decodeJwt from 'jwt-decode';

export const loginRequest = {
    scopes: [`api://${process.env.REACT_APP_API_CLIENT_ID}/access_as_user`],
    // scopes: [`api://${process.env.REACT_APP_API_CLIENT_ID}/access_as_user`, 'group.Read.All'],
};

export const msalConfig = {
    auth: {
        clientId: process.env.REACT_APP_CLIENT_ID,
        redirectUri: process.env.REACT_APP_ENDPOINT,
        authority:
            'https://login.microsoftonline.com/' +
            process.env.REACT_APP_TENANT_ID,
        navigateToLoginRequestUrl: true
    },
    cache: {
        cacheLocation: 'sessionStorage',
        storeAuthStateInCookie: false,
    },
    system: {
        // loggerOptions: {
        //     loggerCallback(loglevel, message, containsPii) {
        //         console.log(message);
        //     },
        //     piiLoggingEnabled: false,
        //     logLevel: msal.LogLevel.Verbose,
        // },
        windowHashTimeout: 60000,
        iframeHashTimeout: 6000,
        loadFrameTimeout: 0,
    },
};

export async function getIdTokenClaims(msalInstance) {
    try {
        const authResult = await msalInstance.acquireTokenSilent(loginRequest);
        return authResult.idTokenClaims;
    } catch (error) {
        if (error instanceof InteractionRequiredAuthError) {
            const authResult =  await msalInstance.acquireTokenRedirect(loginRequest);
            return authResult.accessToken;
        } else {
            console.error(error);
        }
    }
}

export async function getAccessToken(msalInstance) {
    try {
        const authResult = await msalInstance.acquireTokenSilent(loginRequest);
        return authResult.accessToken;
    } catch (error) {
        if (error instanceof InteractionRequiredAuthError) {
            const authResult =  await msalInstance.acquireTokenRedirect(loginRequest);
            return authResult.accessToken;
        } else {
            console.error(error);
        }
    }
}

export function aquireToken(msalInstance) {
    msalInstance
        .acquireTokenSilent(loginRequest)
        .then((tokenResponse) => {
            const decodedToken = decodeJwt(tokenResponse.accessToken);
            localStorage.setItem('access_token', tokenResponse.accessToken);
            localStorage.setItem('role', decodedToken.role);
            localStorage.setItem('upn', decodedToken.upn);
            localStorage.setItem('name', decodedToken.name);
            localStorage.setItem('ipaddr', decodedToken.ipaddr);
            console.log(
                Date() +
                    ': ' +
                    decodedToken.upn +
                    ' logged in from ' +
                    decodedToken.ipaddr
            );
            //console.log("TOKEN - ", tokenResponse.accessToken)
        })
        .catch((error) => {
            if (error instanceof msal.InteractionRequiredAuthError) {
                // fallback to interaction when silent call fails
                return msalInstance.acquireTokenRedirect(loginRequest);
            }
        });
}
